import React from 'react';
import glamorous from 'glamorous';

const Container = glamorous.div({
  width: '100%',
  padding: '30px 0px',
});

const Rule = glamorous.div(
  {
    borderTop: '1px solid',
    margin: '0 auto',
    width: '100%',
  },
  ({ color, theme: { colors } }) => ({
    borderColor: '#c6c6c6',
  })
);

const HorizontalRule = ({ color }) => {
  return (
    <Container>
      <Rule color={color} />
    </Container>
  );
};

export default HorizontalRule;



// WEBPACK FOOTER //
// ./src/App/account/components/HorizontalRule/index.js